import { render, staticRenderFns } from "./UserAcceptTOS.vue?vue&type=template&id=4fa3650a&scoped=true"
import script from "./UserAcceptTOS.vue?vue&type=script&lang=js"
export * from "./UserAcceptTOS.vue?vue&type=script&lang=js"
import style0 from "./UserAcceptTOS.vue?vue&type=style&index=0&id=4fa3650a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa3650a",
  null
  
)

export default component.exports